import styled from 'styled-components';
import { Typography } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

import { ReactComponent as InfoIcon } from '../../../../../assets/icons/v2/exclamation.svg';
import colors from '../../../../../styles/colors';

const RowWrapper = styled.div`
  width: 100%;
  max-width: 800px;
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  padding: 10px;
  margin: 5px 0;
  background-color: ${({ $isCoachView, $isLocked }) => {
    if (!$isCoachView) return colors.shades.gamma4;
    return $isLocked ? colors.shades.gamma13 : colors.shades.gamma4;
  }};
`;

const FieldsContainer = styled.div`
  width: 100%;
  padding-left: 30px;
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  align-items: center;
  justify-content: space-between;
`;

const QuestionMetaContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`;

const ButtonsContainer = styled.div`
  display: flex;
`;

const StyledTypography = styled(Typography)`
  font-weight: bold;
`;

const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  column-gap: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  color: ${colors.base.alpha};
  background-color: ${colors.shades.gamma6};
`;

const DefaultFieldIndicator = styled.div`
  width: fit-content;
  font-size: 12px;
  border-radius: 10px;
  margin-left: 30px;
  display: flex;
  column-gap: 5px;
  justify-content: center;
  align-items: center;
`;

const StyledInfoIcon = styled(InfoIcon)`
  width: 15px;
  height: 15px;
`;

const StyledHelpIcon = styled(HelpOutlineIcon)`
  width: 14px;
  height: 14px;
  color: inherit;
  cursor: pointer;
  vertical-align: middle;
`;

export {
  RowWrapper,
  StyledTypography,
  QuestionMetaContainer,
  FieldsContainer,
  ButtonsContainer,
  DefaultFieldIndicator,
  StyledInfoIcon,
  StyledHelpIcon,
  StatusBadge,
};
